import type { HTMLAttributes, MouseEvent } from 'react';
import { clsx } from '../clsx';
import styles from './Overlay.module.css';

export interface OverlayProps extends HTMLAttributes<HTMLDivElement> {
  /** Distance from the top: 60 leaves the topbar visible (the default of every dialog), 0 covers the page. */
  top?: number | undefined;
  /** `dialog` = rgba(12,23,39,.28) + 2 px blur (Kontakte 04–08); `strong` = .44 + glass blur (Einstellungen 03, 13). */
  strength?: 'dialog' | 'strong' | undefined;
  /** Called on a click on the scrim itself (not on children). */
  onScrimClick?: (() => void) | undefined;
  /** `position: absolute` inside a positioned frame instead of covering the viewport (preview frames, the screens' mock frames). */
  absolute?: boolean | undefined;
}

/** The scrim under dialogs and sheets: fixed, below the topbar, `--z-modal`. */
export function Overlay({
  top = 60,
  strength = 'dialog',
  onScrimClick,
  absolute = false,
  className,
  style,
  ...rest
}: OverlayProps) {
  function handleClick(event: MouseEvent<HTMLDivElement>) {
    if (event.target === event.currentTarget) onScrimClick?.();
  }
  return (
    <div
      className={clsx(
        styles.overlay,
        strength === 'strong' && styles.strong,
        absolute && styles.absolute,
        className,
      )}
      style={{ top, ...style }}
      onClick={handleClick}
      {...rest}
    />
  );
}
